module.exports = __webpack_public_path__ + "static/media/icon_tips_red.88c96e55.svg";